import { z } from 'zod';
import { InputRegexMap, OnboardingFormFields } from '@Types/index.ts';
import { HomeAddressFormScheme } from '@Pages/happyFlowPages/homeAddress/homeAddressForm/HomeAddressFormScheme.ts';
import { t } from 'i18next';
import { birthDateSchema } from '@Schema/birthDateSchema';
import { ssnSchema } from '@Schema/ssnSchema';

export const OwnerFormScheme = HomeAddressFormScheme.extend({
  [OnboardingFormFields.FIRST_NAME]: z
    .string()
    .min(1, t('enErrors:firstNameRequired'))
    .min(2, t('enErrors:firstNameTooShort'))
    .max(30, t('enErrors:firstNameTooLong'))
    .regex(/^[a-zA-Z-_ ]*$/, t('enErrors:firstNameInvalid')),
  [OnboardingFormFields.LAST_NAME]: z
    .string()
    .min(1, t('enErrors:lastNameRequired'))
    .min(2, t('enErrors:lastNameRequired'))
    .max(30, t('enErrors:lastNameTooLong'))
    .regex(/^[a-zA-Z-_ ]*$/, t('enErrors:lastNameInvalid')),
  [OnboardingFormFields.PHONE_NUMBER]: z
    .string()
    .trim()
    .min(1, t('enErrors:phoneRequired'))
    .regex(InputRegexMap.phoneUS, t('enErrors:phone')),
  [OnboardingFormFields.EMAIL]: z
    .string()
    .email(t('enErrors:emailFormat'))
    .min(1, t('enErrors:emailRequired')),

  [OnboardingFormFields.OWNER_PERCENTAGE]: z
    .number({
      required_error: t('enErrors:ownerCenter.ownershipPercentageRequired'),
      invalid_type_error: t('enErrors:ownerCenter.ownershipPercentageRequired'),
    })
    .min(25, t('enErrors:addOwner.ownershipPercentageTooLow'))
    .max(100),
  [OnboardingFormFields.OWNER_ACCESS_GRANTED]: z.boolean(),
  ...ssnSchema.shape,
  ...birthDateSchema.shape,
});
